export type Language = 'is' | 'en'

export const translations = {
  is: {
    navbar: {
      home: 'Heim',
      about: 'Um mig',
      services: 'Þjónusta',
      contact: 'Hafa samband',
      bookNow: 'Bóka núna',
      servicesDropdown: {
        overview: 'Yfirlit',
        courses: 'Námskeið',
        workshops: 'Vinnustofur',
        talks: 'Fræðsla',
      },
    },
    footer: {
      tagline:
        'Þjálfun og ráðgjöf sem byggir á rannsóknum, reynslu og hreinskilni - fyrir leiðtoga og teymi sem vilja gera betur.',
      explore: 'Kanna',
      home: 'Heim',
      about: 'Um mig',
      services: 'Þjónusta',
      contact: 'Hafa samband',
      servicesTitle: 'Þjónusta',
      firstTimeManager: 'Stjórnandi í Fyrsta Sinn',
      healthyConflicts: 'Heilbrigðir Ágreiningar',
      artOfFacilitation: 'Listin að Lóðsa',
      agileLeadership: 'Agile Leiðtogafærni',
      connectTitle: 'Við skulum tengjast',
      copyright: 'Allur réttur áskilinn.',
      privacy: 'Persónuverndarstefna',
      terms: 'Þjónustuskilmálar',
    },
    home: {
      hero: {
        badge: 'Leiðtogar · Teymi · Samskipti',
        titleStart: 'Betri ',
        heart: 'leiðtogar',
        and: ' og ',
        courage: 'sterkari teymi',
        description:
          'Þjálfun og ráðgjöf fyrir leiðtoga og teymi sem vilja skilja hvað virkar í raun - og hvers vegna flest virkar ekki.',
        cta: 'Hafa samband',
        ctaSecondary: 'Skoða þjónustu',
      },
      badge: {
        leaders: '500+ Þátttakendur',
        subtitle: 'Leiðtogar og teymi',
      },
      pillars: {
        title: 'Ekki hefðbundin nálgun',
        subtitle:
          'Gagnreyndur grunnur, hagnýtar aðferðir, hreinskilni um hvað virkar',
        energy: {
          title: 'Gagnreyndar aðferðir',
          desc: 'Við byggjum á rannsóknum - ekki bara hugmyndafræði. Hvað segir vísindin um hvernig teymi þróast, hvernig traust myndast og hvernig stjórnendur geta gert gæfumuninn?',
        },
        connection: {
          title: 'Tenging og Traust',
          desc: 'Traust er ekki gefið - það er byggt upp í gegnum átök og vandamál sem leyst eru saman. Við förum yfir hvernig það virkar í raun.',
        },
        teams: {
          title: 'Teymi og Samstarf',
          desc: 'Flestir hafa meiri slæma reynslu af teymisvinnu en góða. Það er ekki tilviljun - og það er hægt að laga það.',
        },
      },
      services: {
        sectionLabel: 'Hvað ég geri',
        title: 'Leiðir fyrir okkur að vinna saman',
        viewAll: 'Skoða alla þjónustu',
        learnMore: 'Læra meira',
        items: {
          firstTime: {
            title: 'Stjórnandi í Fyrsta Sinn',
            desc: 'Sex vikna hraðnámskeið fyrir fyrstu stjórnendur sem eru tilbúnir að stíga upp.',
            tags: ['Námskeið', 'Þjálfun'],
          },
          conflicts: {
            title: 'Heilbrigðir Ágreiningar',
            desc: 'Hættu að forðast erfið samtöl og byrjaðu að leysa vandamál.',
            tags: ['Vinnustofa', 'Teymi'],
          },
          facilitation: {
            title: 'Listin að Lóðsa | Betri Vinnufundir og Vinnustofur',
            desc: 'Lærðu að hanna og leiða rafræna fundi, viðburði og vinnustofur sem gera fjarvinnu skemmtilegri, skila árangri og halda þátttakendum áhugasömum og einbeittum frá upphafi til enda',
            tags: ['Þjálfun', 'Færni'],
          },
        },
      },
      cta: {
        title: 'Áhugi?',
        description:
          'Við skulum taka spjallið um þínar/ykkar áskoranir og sjá hvort við náum tengingu. Enginn þrýstingur - bara heiðarleg samtal.',
        bookCall: 'Bóka fritt spjall',
        readAbout: 'Lesa um mig',
      },
    },
    about: {
      title: 'Helgi Guðmundsson',
      intro:
        'Fyrirtækja- og stjórnendaþjálfi, vöruþjálfi, leiðsögumaður og kennari. Ég hef eytt meira en áratug í að vinna með leiðtogum, teymum og fyrirtækjum - fyrst í Svíþjóð, nú á Íslandi.',
      pill1: 'Rannsóknarstuddar aðferðir',
      pill2: 'Hagnýtt - ekki fræðilegt',
      storyTitle: 'Hvað ég geri og hvers vegna',
      storyP1:
        'Ég hef starfað sem þjálfi og leiðbeinandi í yfir tíu ár - þjálfað hundruð leiðtoga og teymi í Skandinavíu og á Íslandi, kennt við IHM Viðskiptaháskóla í Gautaborg og þjálfað yfir 90 alþjóðlega leiðbeinendur sem Director of Facilitator Experience hjá Agile People.',
      storyP2:
        'Bakgrunnur minn er í vinnu- og fyrirtækjasálfræði frá Gautaborgarháskóla, sérhæfð þjálfun í úrlausn ágreininga og lóðsun, og ICF ACC vottun í markþjálfun. Ég er einnig meðhöfundur tveggja kafla í bókinni Agile People Principles - útgefinni 2021.',
      storyP3:
        'Nálgun mín er vísvitandi þverfagleg - ég nýt mér þekkingu úr vinnustaðasálfræði, hegðunarvísindum, flókinni kerfahugsun og agile-þjálfun, af því að vandamálin sem ég vinn með passa sjaldan fallega inn í eitt fagsvið. Ég reyni líka að styðjast eins mikið og hægt er við rannsóknir og gögn um hvað virkar og hvað ekki - sem þýðir stundum að ég segi fólki að endurgjafarnálgunin sem þau hafa notað í mörg ár virkar í raun gegn hvernig við lærum og þróumst. Það samtal gengur merkilegt nóg oftast alveg þokkalega.',
      publicationLabel: 'Rit',
      publication: {
        title: 'Agile People Principles',
        subtitle: 'Your Call to Action for the Future of Work - útgefin 2021',
        chapters:
          'Meðhöfundur kafla um „Appreciative Feedback" og „Emergent Strategy"',
      },
      credentialsTitle: 'Vottanir og þjálfun',
      timelineTitle: 'Ferilskrá í stuttu máli',
      timeline: [
        {
          year: '2006–2013',
          title: 'Viðskipti, sala og nám',
          desc: 'Viðskiptafræði og alþjóðaviðskipti frá HR. Síðan sala og markaðsetning hjá Póstinum.  Flutti til Svíþjóðar haust 2011 og hóf nám í vinnusálfræði í Gautaborg.',
        },
        {
          year: '2013–2017',
          title: 'Vinnu- og fyrirtækjasálfræði',
          desc: 'Fil.Cand. frá Gautaborgarháskóla. Sérhæfð þjálfun í úrlausn ágreininga og lóðsun. ICF ACC markþjálfun hjá Gothia Academy.',
        },
        {
          year: '2017–2022',
          title: 'Alþjóðleg þjálfun og kennsla',
          desc: 'Founder Institute Gautaborg, Global Coach hjá Egencia (Expedia Group), Director of Facilitator Experience hjá Agile People - þjálfaði ~90 alþjóðlega leiðbeinendur og var meðhöfundur ICAgile námskeiðs.',
        },
        {
          year: '2021–2023',
          title: 'Stundakennari - IHM Gautaborg',
          desc: '10 vikna stafrænt námskeið í nútíma vöruþróun. Vendikennsla - innspilað efni og verklegar vinnustofur.',
        },
        {
          year: '2022–',
          title: 'Orgz ehf - Ísland',
          desc: 'Stofnaði eigið fyrirtæki. Þjálfun og ráðgjöf fyrir leiðtoga og teymi - námskeið í nútíma vöruþróun, conflict coaching og lóðsun.',
        },
      ],
      writingLabel: 'Skrif og hugsun',
      writingTitle: 'Hvað ég er að hugsa um',
      writingSubtitle:
        'Greinar og kaflar þar sem ég fer yfir hvað rannsóknir segja í raun - og hvað við gerum oft öfugt.',
      outsideWork:
        'Utan vinnu er ég formaður Tangófélags Reykjavíkur, í námi í leiðsögu og ökuleiðsögn - og reyni að gera mig fúsari í að dansa en í að halda fyrirlestra. Gengur misjafnlega.',
    },
    services: {
      title: 'Stuðningur og Þjálfun fyrir',
      titleHighlight: 'Alvöru Árangur',
      subtitle:
        'Hvort sem þú þarft 1:1 stuðning, teymisþjálfun eða sjálfstýrt nám, þá er ég með þig.',
      perPackage: '/ pakki',
      bookService: 'Bóka þessa þjónustu',
      moreInfoCta: 'Nánari upplýsingar',
      moreOptions: 'Fleiri Möguleikar',
      moreOptionsSubtitle:
        'Auk þjálfunar og námskeiða býð ég upp á vinnustofur og fyrirlestrur',
      seeMore: 'Sjá meira',
      items: {
        essentials: {
          title: 'Stjórnandi í Fyrsta Sinn',
          subtitle: 'Fyrir fyrstu stjórnendur',
          description:
            'Hættu að giska og byrjaðu að leiða. Þetta 6 vikna þjálfunaráætlun gefur þér verkfærakistuna sem þú þarft til að stjórna fólki með sjálfstrausti.',
          features: [
            'Vikuleg 1:1 þjálfunarfundir',
            'Sniðmát fyrir 1:1 og endurgjöf',
            'Slack stuðningur milli funda',
            'Persónuleg vaxtaráætlun',
          ],
          price: '$1,499',
        },
        conflict: {
          title: 'Heilbrigðir Ágreiningar',
          subtitle: 'Fyrir teymi í spennu',
          description:
            'Umbreyttu spennu og núning yfir í traust og samvinnu. Skalanleg námskeið og vinnustofur hönnuð til að hjálpa teyminu þínu að sigla um erfið samtöl og byggja upp sálfræðilegt öryggi.\n\nEinnig í boði að koma inn sem lóðs og þjálfi til að leiða betri samtöl þegar ágreiningur er kominn í gang.',
          features: [
            'Skalanleg námskeið og vinnustofur',
            'Verkfæri til að sigla um erfið samtöl',
            'Uppbygging sálfræðilegs öryggis í teymi',
            'Þjálfun og leiðsögn í virkum ágreiningi',
          ],
          price: '$2,500',
        },
        wizardry: {
          title: 'Listin að Lóðsa | Betri Vinnufundir og Vinnustofur',
          subtitle: 'Fyrir upprennandi stjórnendur',
          description:
            'Lærðu að hanna og leiða rafræna fundi, viðburði og vinnustofur sem gera fjarvinnu skemmtilegri, skila árangri og halda þátttakendum áhugasömum og einbeittum frá upphafi til enda',
          features: [
            'Hönnun og leiðsögn rafrænna funda og vinnustofa',
            'Tækni og tól til að auka þátttöku og einbeitingu',
            'Aðferðir til að gera fjarvinnu skemmtilegri',
            'Hagnýtar æfingar og endurgjöf',
          ],
          price: '$499',
        },
        agile: {
          title: 'Agile Leiðtogafærni',
          subtitle: 'Fyrir teymi í umbreytingu',
          description:
            'Lærðu að leiða í flóknari aðstæðum og örari breytingum af auknu öryggi og aðlögunarhæfni. Námskeið og vinnustofur sem flétta saman aðferðafræði Agile og Lean við mannlega leiðtogahæfileika til að efla teymi og skapa betri árangur.',
          features: [
            'Agile grunnhugtök og ramma',
            'Leiðtogahlutverk í Agile teymum',
            'Hagnýtar æfingar og dæmisögur',
            'Stuðningur við innleiðingu',
          ],
          price: '$1,899',
        },
      },
      additional: {
        workshops: {
          title: 'Vinnustofur',
          description:
            'Gagnvirkar vinnustofur á staðnum eða á netinu - frá teymissamvinnu til leiðtogaþjálfunar.',
        },
        talks: {
          title: 'Fræðsla',
          description:
            'Hvetjandi fyrirlestrur frá 30 til 90 mínútum - fullkomnir fyrir ráðstefnur og viðburði.',
        },
        courses: {
          title: 'Námskeið',
          description:
            'Dýpri þjálfun í sérhæfðum efnum - frá conflict coaching til leiðtogafærni og betri vinnustofum á netinu.',
        },
      },
    },
    courses: {
      badge: 'Námskeið',
      title: 'Hagnýt Þekking og Þjálfun fyrir Nútíma Leiðtoga',
      subtitle:
        'Dýpri þjálfun sem skilar varanlegum árangri. Veldu námskeið sem hentar þér eða þínu teymi.',
      benefitsTitle: 'Hvað þú færð út úr námskeiðinu:',
      moreInfo: 'Meiri upplýsingar',
      customTitle: 'Sérsniðin Námskeið?',
      customDescription:
        'Ég held líka námskeið innanhúss hjá fyrirtækjum og get aðlagað efnið að ykkar þörfum.',
      contactUs: 'Hafa samband',
      items: {
        conflictCoaching: {
          title: 'Conflict Coaching',
          subtitle: 'Heilbrigðari Samskipti og Ágreiningar',
          description:
            'Lærðu að tækla ágreining af öryggi og breyta honum í tækifæri til vaxtar. Hagnýtt námskeið sem gefur þér verkfæri til að leiða krefjandi samtöl og byggja upp traust.',
          duration: '2 dagar (með millibili)',
          format: 'Staðnámskeið eða Stafrænt',
          audience: 'Stjórnendur, teymi, HR fagfólk',
          benefits: [
            'Skilningur á eðli ágreinga og hvernig þeir stigmagnast',
            'Aðferðir til að kortleggja og skilja hvað er raunverulega í gangi',
            'Þjálfun í betri hlustun og samtalstækni',
            'Aukið sjálfstraust og færni í krefjandi samtölum',
          ],
        },
        firstTimeManager: {
          title: 'Stjórnandi í Fyrsta Sinn',
          subtitle: 'Byggðu upp sjálfstraust í nýju hlutverki',
          description:
            'Hagnýtt 6 vikna námskeið fyrir nýja stjórnendur. Við förum yfir allt frá hlutverkaskiptum og endurgjöf til teymi og fundarstjórnunar.',
          duration: '6 vikur (ein lota á viku)',
          format: 'Staðnámskeið eða Stafrænt',
          audience: 'Nýir stjórnendur, verðandi stjórnendur',
          benefits: [
            'Skýrari sýn á hlutverkið',
            'Verkfæri til að veita endurgjöf',
            'Aðferðir til að forgangsraða',
            'Hæfni til að byggja upp teymi',
          ],
        },
        betterOnlineMeetings: {
          title: 'Betri Fjarfundir',
          subtitle: 'Vinnustofur og fundir á netinu',
          description:
            'Hættu að halda leiðinlega fjarfundi. Lærðu að skapa orku, tengingu og árangur í gegnum skjáinn með réttum tólum og aðferðum.',
          duration: '2 x 2 klukkustundir',
          format: 'Stafrænt',
          audience: 'Allir sem leiða fundi á netinu',
          benefits: [
            'Aukin þátttaka á fundum',
            'Tækni og tól sem virka',
            'Aðferðir til að brjóta ísinn',
            'Skilvirkari ákvarðanatökuferli',
          ],
        },
        betterOnlineWorkshops: {
          title: 'Betri Vinnustofur á Netinu',
          subtitle: 'Hönnun og leiðsögn vinnustofa',
          description:
            'Fyrir þá sem vilja taka skrefið lengra en bara fundi. Lærðu að hanna og leiða gagnvirkar vinnustofur þar sem þátttakendur eru virkir og læra af eigin reynslu.',
          duration: '3 lotur (3 x 2-3 klst)',
          format: 'Stafrænt',
          audience: 'Leiðbeinendur, þjálfarar, kennarar',
          benefits: [
            'Training from the Back of the Room aðferðafræði',
            'Hönnun gagnvirkra æfinga',
            'Æfing í að flytja eigin vinnustofu',
            'Endurgjöf frá jafningjum',
          ],
        },
        modernProductManagement: {
          title: 'Nútíma Vörustjórnun',
          subtitle: 'Frá hugmynd að árangursríkri vöru',
          description:
            'Lærðu aðferðafræði nútíma vörustjórnunar - frá grunnhugtökum og algengum módel til hagnýtra verkfæra og AI-studdrar prótótýpugerðar. Veldu það snið sem hentar þér best.',
          duration: '½ - 2 dagar',
          format: 'Staðnámskeið eða Stafrænt',
          audience: 'Vörustjórar og verkefnastjórar',
          benefits: [
            'Skilningur á hlutverki vörustjórans í nútíma fyrirtækjum',
            'Algeng módel og ramma vörustjórnunar (Lean, Agile, Jobs-to-be-Done)',
            'Verkfæri til að skilja viðskiptavini og markaðinn',
            'Forgangsröðun og ákvarðanataka í vöruþróun',
            'Hagnýtar æfingar og raunveruleg dæmi',
            'Notkun AI verkfæra til að flýta fyrir prótótýpugerð',
          ],
          formatToggle: {
            inPerson: 'Á staðnum',
            digital: 'Stafrænt (Vendikennsla)',
          },
          inPersonTiers: {
            tier1: {
              name: 'Grunnur',
              duration: '½ dagur',
              subtitle: 'Vörustjórnun 101',
              description:
                'Fullkomin kynning á vörustjórnun fyrir þá sem vilja skilja grunnhugtöklin og hlutverk vörustjórans.',
              features: [
                'Hvað er vörustjórnun?',
                'Hlutverk vörustjórans',
                'Grunnhugtök og orðaforði',
                'Yfirlit yfir vöruþróunarferlið',
                'Dæmi úr raunveruleikanum',
              ],
            },
            tier2: {
              name: 'Viðbót',
              duration: '1 dagur',
              subtitle: 'Módel og Verkfæri',
              description:
                'Grunnurinn plús kynning á algengum módel og verkfærum sem vörustjórar nota daglega.',
              features: [
                'Allt úr Grunni',
                'Lean Startup aðferðafræði',
                'Jobs-to-be-Done rammi',
                'Forgangsröðunarverkfæri (RICE, MoSCoW)',
                'Notendaviðtöl og rannsóknir',
                'Roadmap og áætlanagerð',
              ],
              highlighted: true,
            },
            tier3: {
              name: 'Heildstætt',
              duration: '2 dagar',
              subtitle: 'Verkleg Þjálfun + AI',
              description:
                'Ítarleg þjálfun með verklegum æfingum og prótótýpugerð með hjálp AI verkfæra.',
              features: [
                'Allt úr Viðbót',
                'Verklegar æfingar í hópum',
                'Þróun eigin vöruhugmyndar',
                'AI verkfæri fyrir prótótýpur',
                'Frá hugmynd að MVP',
                'Kynning og endurgjöf',
              ],
            },
          },
          digitalTiers: {
            tier1: {
              name: 'Grunnur',
              sessions: '1x 2.5 klst',
              subtitle: 'Vörustjórnun 101',
              description:
                'Ein gagnvirk vinnustofa sem fer yfir grunnhugtök vörustjórnunar.',
              features: [
                'Hvað er vörustjórnun?',
                'Hlutverk vörustjórans',
                'Grunnhugtök og orðaforði',
                'Gagnvirkar umræður',
                'Kennslumyndbönd til undirbúnings',
              ],
            },
            tier2: {
              name: 'Viðbót',
              sessions: '3x 2.5 klst',
              subtitle: 'Módel og Verkfæri',
              description:
                'Þrjár vinnustofur sem fara dýpra í módel og verkfæri vörustjórnunar.',
              features: [
                'Allt úr Grunni',
                'Lean og Agile aðferðir',
                'Forgangsröðunarverkfæri',
                'Notendarannsóknir',
                'Æfingar milli lota',
                'Kennslumyndbönd fyrir hverja lotu',
              ],
              highlighted: true,
            },
            tier3: {
              name: 'Heildstætt',
              sessions: '6x 2.5 klst',
              subtitle: 'Verkleg Þjálfun + AI',
              description:
                'Sex vinnustofur með verklegum æfingum og AI-studdri prótótýpugerð.',
              features: [
                'Allt úr Viðbót',
                'Verklegar æfingar',
                'Eigin vöruhugmynd þróuð',
                'AI verkfæri kynnt og notuð',
                'Hópavinna og endurgjöf',
                'Kynning á lokaverkefni',
              ],
            },
          },
          digitalNote:
            'Stafræna námskeiðið notar vendikennslu (flipped learning). Þátttakendur horfa á kennslumyndbönd heima og taka síðan þátt í gagnvirkum vinnustofum í gegnum Zoom þar sem við vinnum saman að æfingum og umræðum.',
          forWhom: 'Fyrir hvern?',
          forWhomItems: [
            'Vörustjórar sem vilja styrkja grunninn',
            'Verkefnastjórar sem vilja skilja vörustjórnun',
            'Stofnendur og frumkvöðlar',
            'Hönnuðir og þróunaraðilar sem vinna með vörustjórum',
          ],
          inquiry: 'Fyrirspurn',
          groupTitle: 'Hópafsláttur?',
          groupDesc:
            'Eruð þið fleiri úr sama fyrirtæki? Ég býð upp á sérstök kjör fyrir hópa og get haldið námskeiðið innanhúss hjá ykkur.',
          contactLink: 'Hafa samband',
          ctaTitle: 'Taktu skrefið í átt að betri vörustjórnun',
          ctaDesc:
            'Veldu það snið sem hentar þér og byrjaðu ferðina í átt að árangursríkari vöruþróun.',
          ctaCta: 'Hafa samband',
        },
      },
    },
    workshops: {
      badge: 'Vinnustofur',
      title: 'Gagnvirkt Nám sem',
      titleHighlight: 'Skilar Árangri',
      subtitle:
        'Hvort sem þú vilt hittast augliti til auglis eða á netinu, þá býð ég upp á vinnustofur sem breyta teymi og leiðtogum.',
      inPersonTitle: 'Á Staðnum',
      inPersonSubtitle: 'Vinnustofur þar sem við hittumst augliti til auglis',
      onlineTitle: 'Á Netinu',
      onlineSubtitle: 'Lifandi vinnustofur með leiðsögn á netinu',
      getQuote: 'Fá tilboð',
      customTitle: 'Sérhannaðar Vinnustofur',
      customDescription:
        'Þarftu eitthvað sérstakt? Ég hanna vinnustofur eftir þínum þörfum - hvort sem það er fyrir lítið teymi eða stóra ráðstefnu.',
      customCta: 'Við skulum ræða saman',
      items: {
        teamDynamics: {
          title: 'Kraftmikil Teymi',
          subtitle: 'Gagnvirk vinnustofa fyrir teymi',
          description:
            'Styrktu samskipti og samvinnu teymið með hagnýtum æfingum og raunverulegum dæmum. Þátttakendur læra hvernig öflug teymi þróast, gildi mismunandi samskiptastíla og hvernig við byggjum upp skothelt traust.',
          duration: 'Hálfur dagur (4 klst) eða heilur dagur (8 klst)',
          format: 'Á staðnum hjá þér eða á fundarstað',
          benefits: [
            'Hagnýtar æfingar í hóp',
            'Raunverulegar atburðarásir',
            'Teymistenging og traust',
            'Aðgerðaáætlun til að taka með',
          ],
        },
        leadershipIntensive: {
          title: 'Stjórnandi og Leiðtogi',
          subtitle: 'Fyrir nýja og reynda stjórnendur',
          description:
            'Dýpkaðu leiðtogahæfileika þína í öflugu námsumhverfi. Vinnustofan blandar saman kenningum, sjálfsígrundun og hagnýtum verkfærum sem þú getur notað strax.',
          duration: 'Heilur dagur (8 klst)',
          format: 'Á staðnum með hámarki 12 þátttakendum',
          benefits: [
            'Persónuleg leiðtogagreining',
            'Hlutverkaleikir og endurgjöf',
            'Verkfærakista fyrir daglega notkun',
            'Tengslanet við aðra leiðtoga',
          ],
        },
        virtualFacilitation: {
          title: 'Árangursríkari Fjarfundir',
          subtitle: 'Listin að leiða betri og skemmtilegri fjar-viðburði',
          description:
            'Umbreyttu leiðinlegum fjarfundum og vinnustofum í gagnvirka og árangursríka fundi sem þáttakendur elska að taka þátt í. Lærðu tækni og tól til sem halda athygli og skila raunverulegum árangri.',
          duration: '2 x 2 klukkustundir (tvær lotur)',
          format: 'Lifandi á netinu með hagnýtum æfingum',
          benefits: [
            'Tækni fyrir gagnvirkni á netinu',
            'Verkfæri og sniðmát',
            'Æfing í öruggu umhverfi',
            'Upptökur til endurskoðunar',
          ],
        },
        remoteTeam: {
          title: 'Fjarteymi sem Virkar',
          subtitle: 'Byggðu sterka teymismenningu á fjarlægð',
          description:
            'Lærðu að byggja upp og viðhalda sterkri teymismenningu þegar teymið er dreift. Frá samskiptareglum til óformlegra tengsla - allt sem þarf til að fjarteymi blómstri.',
          duration: 'Hálfur dagur (4 klst)',
          format: 'Lifandi á netinu með breakout rooms',
          benefits: [
            'Samskiptareglur fyrir fjarteymi',
            'Tól fyrir óformlega tengingu',
            'Aðferðir við að byggja traust',
            'Sniðmát og gátlistar',
          ],
        },
      },
    },
    talks: {
      badge: 'Fræðsla',
      title: 'Hugmyndir sem',
      titleHighlight: 'Hreyfa við Fólki',
      subtitle:
        'Frá styttri hugsprettum til dýpri skilnings - ég kemst á svið og miðla innsýn sem stuðlar að breytingum.',
      chooseTitle: 'veljið það sem hentar ykkur',
      chooseSubtitle:
        'Þrjár nálganir sniðnar að þörfum viðburðarins og áhorfenda',
      idealFor: 'Hentar vel fyrir:',
      topicsLabel: 'Efni',
      formatLabel: 'Snið',
      bookTalk: 'Bóka þennan fyrirlestur',
      popularTopics: 'Vinsæl Efni',
      popularTopicsSubtitle:
        'Ég tala um ýmis efni tengd leiðtogum, teymum og vinnustaðamenningu',
      customTitle: 'Sérsniðinn Fyrirlestur?',
      customDescription:
        'Ef þú hefur sérstakt efni í huga eða vilt aðlaga fyrirlestur að þínum viðburði, þá er ég tilbúinn að vinna með þér.',
      customCta: 'Hafðu samband',
      items: {
        short: {
          title: 'Stutt og Snarpt',
          duration: '30-40 mínútur',
          subtitle: 'Stutt og slagkraftur',
          description:
            'Fullkomið fyrir hádegisverðarfundi, opnun viðburða eða þegar þú þarft skapandi boozt sem setur tóninn. Þétt og áhrifaríkt innihald sem hvetur til umhugsunar.',
          idealFor:
            'Hádegisverðarfundir, opnunarræður, orkusprengja fyrir lengri viðburði',
          topics: [
            'Leiðtogahugarfar',
            'Teymissamvinna',
            'Breytingastjórnun',
            'Skapandi lausnir',
          ],
          format: [
            '25 mín fyrirlestur + 5 mín spurningar',
            'Gagnvirk þátttaka',
            'Einn til tveir lykilboðskapur',
          ],
        },
        standard: {
          title: 'Aðalfyrirlestur',
          duration: '60 mínútur',
          subtitle: 'Klassískt snið',
          description:
            'Hefðbundinn fyrirlestur sem fer dýpra í efnið. Fullkomið fyrir ráðstefnur, fyrirtækjaviðburði eða þegar þú vilt veita áhorfendum raunverulega innsýn og hagnýt verkfæri.',
          idealFor: 'Ráðstefnur, ársfundir, fyrirtækjaviðburðir, fagdagar',
          topics: [
            'Leiðtogaþróun',
            'Sálfræðilegt öryggi',
            'Agile hugarfar',
            'Teymismenning',
            'Krefjandi Samtöl',
            'Endurgjöf sem Virkar',
          ],
          format: [
            '45-50 mín fyrirlestur + 10-15 mín spurningar',
            'Sögur og dæmi úr raunveruleikanum',
            'Hagnýt verkfæri og ráð',
          ],
        },
        deepDive: {
          title: 'Á Djúpið',
          duration: '90 mínútur',
          subtitle: 'Gagnvirkur fyrirlestur',
          description:
            'Meira en fyrirlestur - þetta er upplifun. Blandar saman fyrirlestri, hagnýtum æfingum og umræðum.. fullkomið þegar þú vilt að þátttakendur fái ekki bara þekkingu heldur líka prufukeyrslu á nýjum aðferðum.',
          idealFor:
            'Leiðtogadagar, þróunardagar, sérhæfðir hópar sem vilja dýpka skilning',
          topics: [
            'Conflict Coaching',
            'Ferðalag Leiðtogans',
            'Þróun kraftmikilla Teyma',
            'Betri Breytingar',
          ],
          format: [
            '60 mín fyrirlestur + 20 mín æfingar + 10 mín umræður',
            'Gagnvirkar æfingar í hópum',
            'Dýpri umræður og spurningar',
            'Aðgerðaáætlun til að taka með',
          ],
        },
      },
      topicsList: {
        leadership: {
          title: 'Leiðtogaþróun',
          description: 'Frá fyrsta skrefum að reyndum leiðtoga',
        },
        teams: {
          title: 'Öflug Teymi',
          description: 'Að byggja upp traust og samvinnu',
        },
        agile: {
          title: 'Agile & Lean',
          description: 'Aðlögunarhæfni í flóknum heimi',
        },
        creative: {
          title: 'Skapandi Lausnir',
          description: 'Nýsköpun og Nútíma Vöruþróun',
        },
      },
    },
    contact: {
      title: 'Við skulum tala saman',
      subtitle:
        'Fylltu út eyðublaðið eða bókaðu tíma beint í dagatalinu mínu. Enginn þrýstingur — bara heiðarleg samtal.',
      infoTitle: 'Tengiliðaupplýsingar',
      emailLabel: 'Sendu mér tölvupóst',
      locationLabel: 'Staðsetning',
      locationValue: 'Reykjavík / Um allan heim',
      bookCallTitle: 'Bóka símtal',
      bookCallDesc:
        'Slepptu tölvupóstaleiknum og náðu í tíma í dagatalinu mínu fyrir ókeypis 15 mínútna kynnispjall.',
      viewCalendar: 'Skoða dagatalstíma',
      formTitle: 'Senda skilaboð',
      firstName: 'Fornafn',
      firstNamePlaceholder: 'Jóna',
      lastName: 'Eftirnafn',
      lastNamePlaceholder: 'Jónsdóttir',
      email: 'Netfang',
      emailPlaceholder: 'jona@example.com',
      interestLabel: 'Mig langar að vita meira um...',
      interestOptions: [
        'Stjórnandi í Fyrsta Sinn',
        'Heilbrigðir Ágreiningar',
        'Listin að Lóðsa | Betri Vinnufundir og Vinnustofur',
        'Almenn fyrirspurn',
      ],
      message: 'Skilaboð',
      messagePlaceholder:
        'Segðu mér aðeins um markmið þín eða áskoranirnar sem þú stendur frammi fyrir...',
      send: 'Senda skilaboð',
      successTitle: 'Skilaboð send!',
      successMessage:
        'Takk fyrir að hafa samband. Ég kem til baka til þín innan 24 klukkustunda.',
      sendAnother: 'Senda önnur skilaboð',
    },
    conflictCoaching: {
      badge: 'Conflict Coaching',
      title: 'Heilbrigðari Samskipti og',
      titleHighlight: 'Ágreiningar á Vinnustöðum',
      subtitle:
        'Lærðu að takast á við ágreining af öryggi og breyta honum í tækifæri til vaxtar og betri samskipta.',
      duration: '2 dagar (með millibili)',
      audience: 'Fyrir stjórnendur og HR',
      format: 'Vinnustofa',
      bookCta: 'Bóka pláss eða fá tilboð',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Ágreiningur er óhjákvæmilegur hluti af samstarfi fólks. Spurningin er ekki hvort hann komi upp, heldur hvernig við tökum á honum. Á þessu námskeiði lærir þú aðferðafræði Conflict Coaching til að leiða fólk í gegnum ágreining á uppbyggilegan hátt.',
      aboutP2:
        'Við förum yfir hvernig heilinn bregst við ógn, hvernig við getum róað aðstæður og skapað rými fyrir raunverulegt samtal. Þú færð verkfæri til að hjálpa öðrum (og sjálfum þér) að sjá sjónarhorn annarra og finna sameiginlegan flöt.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skilningur á eðli átaka og ágreinings',
        'Aðferðir til að greina rót vandans',
        'Betri hlustun og spurningatækni',
        'Aukið sjálfstraust í erfiðum samtölum',
        'Verkfæri til að breyta átökum í tækifæri',
        'Uppbygging trausts í teymi',
      ],
      structureTitle: 'Uppbygging',
      curriculum: [
        {
          day: 'Dagur 1',
          title: 'Grunnurinn og Greining',
          topics: [
            'Hvað er Conflict Coaching?',
            'Mismunandi átakastílar',
            'Taugafræði átaka (Fight/Flight/Freeze)',
            'Greining á stöðunni - Kortlagning',
          ],
        },
        {
          day: 'Millibil',
          title: 'Æfingar og Ígrundun',
          topics: [
            'Verkefni í eigin umhverfi',
            'Ígrundunardagbók',
            'Undirbúningur fyrir dag 2',
          ],
        },
        {
          day: 'Dagur 2',
          title: 'Lausnir og Framkvæmd',
          topics: [
            'Að stýra erfiðum samtölum',
            'Framtíðarsýn og lausnir',
            'Æfingar í hlutverkaleikjum',
            'Aðgerðaáætlun til framtíðar',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Stjórnendur sem vilja efla samskiptafærni sína',
        'HR fagfólk sem styður við teymi og stjórnendur',
        'Teymisstjórar sem vilja byggja upp sálfræðilegt öryggi',
      ],
      inquiry: 'Fyrirspurn',
      questionsTitle: 'Ertu með spurningar?',
      questionsDesc:
        'Hikaðu ekki við að hafa samband ef þú vilt vita hvort þetta námskeið henti þér eða þínu teymi.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Taktu skrefið í átt að betri samskiptum',
      ctaDesc:
        'Bókaðu námskeið fyrir hópinn þinn eða skráðu þig á næsta opna námskeið.',
      ctaCta: 'Hafa samband',
    },
    firstTimeManager: {
      badge: 'Stjórnandi í Fyrsta Sinn',
      title: 'Byggðu upp Sjálfstraust í',
      titleHighlight: 'Nýju Hlutverki',
      subtitle:
        'Hagnýtt 6 vikna námskeið fyrir nýja stjórnendur sem vilja byrja ferilinn sinn af krafti og öryggi.',
      duration: '6 vikur (ein lota á viku)',
      audience: 'Nýir stjórnendur',
      certificate: 'Vottorð að lokum',
      bookCta: 'Skráning og nánari upplýsingar',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Að taka við stjórnunarstöðu í fyrsta sinn er eitt stærsta stökk sem fólk tekur á starfsferlinum. Allt í einu snýst starfið ekki lengur um það sem þú gerir sjálf/ur, heldur hvernig þú færð aðra til að blómstra.',
      aboutP2:
        'Þetta námskeið er hannað til að brúa bilið. Við förum yfir grunnatriði stjórnunar, allt frá því að halda góða 1:1 fundi til þess að takast á við erfið starfsmannamál. Markmiðið er að þú gangir út með verkfærakistu sem nýtist þér strax á fyrsta degi.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skýrari sýn á hlutverk stjórnandans',
        'Aukið sjálfstraust í nýju hlutverki',
        'Verkfæri til að veita endurgjöf',
        'Aðferðir til að forgangsraða og stýra tíma',
        'Hæfni til að halda árangursríka fundi',
        'Skilningur á hvernig á að byggja upp teymi',
      ],
      scheduleTitle: 'Dagskráin (6 vikur)',
      curriculum: [
        {
          week: 'Vika 1',
          title: 'Hlutverkaskiptin',
          desc: 'Frá sérfræðingi yfir í stjórnanda. Hvað breytist? Hvernig byggjum við traust?',
        },
        {
          week: 'Vika 2',
          title: 'Samskipti og Endurgjöf',
          desc: 'Að veita og þiggja endurgjöf. Erfið samtöl og hrós.',
        },
        {
          week: 'Vika 3',
          title: 'Teymisuppbygging',
          desc: 'Hvernig verða teymi til? Hlutverk stjórnandans í að skapa menningu.',
        },
        {
          week: 'Vika 4',
          title: 'Fundir og Skipulag',
          desc: 'Að stýra fundum sem skila árangri. Tímastjórnun og forgangsröðun.',
        },
        {
          week: 'Vika 5',
          title: 'Markmiðasetning og Frammistaða',
          desc: 'Hvernig setjum við markmið? Hvernig fylgjum við þeim eftir?',
        },
        {
          week: 'Vika 6',
          title: 'Minn Stjórnunarstíll',
          desc: 'Samantekt og framtíðarsýn. Hvers konar leiðtogi vil ég vera?',
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Nýir stjórnendur (0-2 ár í starfi)',
        'Sérfræðingar sem eru að taka við teymi',
        'Verkefnastjórar með mannaforráð',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hóptilboð?',
      groupDesc:
        'Eruð þið með hóp af nýjum stjórnendum? Ég get haldið þetta námskeið sérstaklega fyrir ykkar fyrirtæki.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Fjárfestu í framtíðarleiðtogum',
      ctaDesc:
        'Gefðu nýjum stjórnendum þann stuðning sem þeir þurfa til að ná árangri.',
      ctaCta: 'Hafa samband',
    },
    betterOnlineMeetings: {
      badge: 'Betri Fjarfundir',
      title: 'Betri Fjarfundir',
      titleHighlight: 'á Netinu',
      subtitle:
        'Hættu að halda leiðinlega fjarfundi. Lærðu að skapa orku, tengingu og árangur í gegnum skjáinn.',
      duration: '2 x 2 klst',
      audience: 'Fyrir alla fundarstjóra',
      online: '100% á netinu',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Fjarvinna er komin til að vera, en margir fundir eru ennþá bara "venjulegir fundir í tölvu". Það virkar sjaldnast vel. Á netinu þurfum við aðra nálgun, önnur verkfæri og meiri meðvitund um orku og athygli.',
      aboutP2:
        'Á þessu stutta og hagnýta námskeiði lærir þú leyndarmálin á bak við frábæra fjarfundi. Við förum yfir tæknina (án þess að flækja málin) og aðferðafræðina sem heldur fólki við efnið.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Aukin þátttaka á fjarfundum',
        'Betri nýting á tíma fundarmanna',
        'Tækni og tól sem virka',
        'Aðferðir til að brjóta ísinn',
        'Hvernig við höldum orkunni uppi',
        'Skilvirkari ákvarðanatökuferli',
      ],
      structureTitle: 'Uppbygging (2 lotur)',
      sessions: [
        {
          title: 'Lota 1: Grunnurinn og Tæknin',
          desc: 'Hvernig undirbúum við góðan fjarfund? Hvaða tól notum við? Hvernig tryggjum við að allir heyrist?',
          topicsLabel: 'Viðfangsefni:',
          topics: [
            'Uppsetning og tæknimál',
            'Miro/Mural og önnur samvinnutól',
            'Að skapa öruggt rými á netinu',
            'Ísbrjótar og tenging',
          ],
        },
        {
          title: 'Lota 2: Aðferðir og Framkvæmd',
          desc: 'Hvernig stýrum við umræðum? Hvernig vinnum við í hópum? Hvernig ljúkum við fundi með skýrum niðurstöðum?',
          topicsLabel: 'Viðfangsefni:',
          topics: [
            'Breakout rooms og hópavinna',
            'Aðferðir við ákvarðanatöku',
            'Að takast á við "Zoom fatigue"',
            'Eftirfylgni og næstu skref',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Verkefnastjórar og teymisstjórar',
        'Leiðbeinendur og kennarar',
        'Allir sem stýra fundum á netinu',
      ],
      inquiry: 'Fyrirspurn',
      privateTitle: 'Einkatímar?',
      privateDesc:
        'Ég býð líka upp á einstaklingsráðgjöf fyrir þá sem vilja skerpa á fjarfundatækninni.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Gerðu næsta fjarfund frábæran',
      ctaDesc: 'Lærðu tæknina og aðferðirnar sem gera gæfumuninn.',
      ctaCta: 'Hafa samband',
    },
    betterOnlineWorkshops: {
      badge: 'Betri Vinnustofur á Netinu',
      title: 'Betri Vinnustofur',
      titleHighlight: 'á Netinu',
      subtitle:
        'Lærðu að hanna og leiða gagnvirkar, skemmtilegar og árangursríkar vinnustofur á netinu.',
      duration: '3 lotur (3 x 2-3 klst)',
      audience: 'Fyrir leiðbeinendur',
      online: '100% á netinu',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Að leiða vinnustofur á netinu krefst annarrar nálgunar en í raunheimum. Það er ekki nóg að "færa fundinn á Zoom". Við þurfum að hanna upplifunina þannig að hún haldi fólki við efnið, skapi virkni og skila raunverulegum árangri.',
      aboutP2:
        'Á þessu námskeiði lærir þú bæði tæknina og aðferðafræðina. Við notum "Training from the Back of the Room" nálgunina til að skapa virkt nám, og þú færð tækifæri til að æfa þig með því að hanna og flytja þína eigin "micro-vinnustofu".',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Tækni og tól til að leiða vinnustofur á netinu',
        '"Training from the Back of the Room" aðferðafræðin',
        'Hönnun gagnvirkra og skemmtilegra vinnustofa',
        'Að halda orku og athygli þátttakenda',
        'Hagnýt reynsla af að flytja eigin vinnustofu',
        'Endurgjöf frá leiðbeinanda og öðrum þátttakendum',
      ],
      structureTitle: 'Uppbygging (3 lotur)',
      topicsLabel: 'Viðfangsefni:',
      homework: 'Heimaverkefni',
      sessions: [
        {
          title: 'Lota 1: Tæki, Tól og Tækni',
          desc: 'Fyrsta lotan snýst um grunninn - hvaða tól og tækni þurfum við til að leiða frábærar vinnustofur á netinu?',
          topics: [
            'Miro/Mural og samvinnutól',
            'Zoom/Teams aðgerðir fyrir leiðbeinendur',
            'Breakout rooms og hópavinna',
            'Tæknileg uppsetning og undirbúningur',
          ],
        },
        {
          title: 'Lota 2: Training from the Back of the Room',
          desc: 'Í annarri lotu kynnumst við aðferðafræðinni "Training from the Back of the Room" - hvernig hönnun við vinnustofur þar sem þátttakendur læra af eigin reynslu?',
          topics: [
            'Aðferðafræði TBR (Training from the Back of the Room)',
            'Hönnun gagnvirkra æfinga',
            'Að skapa nám í stað kennslu',
            'Orkustjórnun og flæði',
          ],
        },
        {
          title: 'Heimaverkefni: Micro-Vinnustofa',
          desc: 'Milli annarrar og þriðju lotu hanna þátttakendur sína eigin 15 mínútna micro-vinnustofu og undirbúa sig til að flytja hana.',
          topics: [
            'Hönnun á 15 mínútna vinnustofu',
            'Undirbúningur fyrir flutning',
            'Æfing á eigin efni',
          ],
          isHomework: true,
        },
        {
          title: 'Lota 3: Flutningur og Endurgjöf',
          desc: 'Í þriðju og síðustu lotu flytja þátttakendur micro-vinnustofuna sína og fá ítarlega endurgjöf frá leiðbeinanda og öðrum þátttakendum.',
          topics: [
            'Flutningur á eigin micro-vinnustofu',
            'Endurgjöf frá leiðbeinanda',
            'Endurgjöf frá jafningjum',
            'Næstu skref og framhald',
          ],
        },
      ],
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Þeir sem leiða vinnustofur eða námskeið',
        'Þjálfarar og ráðgjafar',
        'Kennarar og leiðbeinendur',
        'Allir sem vilja bæta færni sína í leiðsögn',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hópafsláttur?',
      groupDesc:
        'Eruð þið með hóp af leiðbeinendum? Ég býð upp á sérstök kjör fyrir fyrirtæki og stofnanir.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Vertu meistari í að leiða vinnustofur á netinu',
      ctaDesc:
        'Taktu næsta skref í þinni faglegu þróun og lærðu að skapa ógleymanlegar upplifanir á netinu.',
      ctaCta: 'Hafa samband',
    },
    modernProductManagement: {
      badge: 'Nútíma Vörustjórnun',
      title: 'Nútíma Vörustjórnun',
      titleHighlight: 'fyrir Árangur',
      subtitle:
        'Lærðu aðferðafræði nútíma vörustjórnunar - frá grunnhugtökum til AI-studdrar prótótýpugerðar. Veldu það snið sem hentar þér best.',
      duration: '½ - 2 dagar',
      audience: 'Vörustjórar og verkefnastjórar',
      format: 'Staðnámskeið eða Stafrænt',
      bookCta: 'Bóka námskeið',
      aboutTitle: 'Um Námskeiðið',
      aboutP1:
        'Vörustjórnun er orðin ein af mikilvægustu greinum nútíma viðskipta. Hvort sem þú ert að þróa hugbúnað, þjónustu eða efnislega vöru, þá skiptir máli að skilja hvernig við förum frá hugmynd til árangursríkrar vöru sem viðskiptavinir elska.',
      aboutP2:
        'Þetta námskeið er í boði á þremur stigum - frá stuttri kynningu á grunnhugtökum upp í ítarlega þjálfun með verklegum æfingum og AI-studdri prótótýpugerð. Veldu það snið sem hentar þínum þörfum og tíma.',
      learnTitle: 'Hvað þú lærir',
      benefits: [
        'Skilningur á hlutverki vörustjórans í nútíma fyrirtækjum',
        'Algeng módel og ramma vörustjórnunar (Lean, Agile, Jobs-to-be-Done)',
        'Verkfæri til að skilja viðskiptavini og markaðinn',
        'Forgangsröðun og ákvarðanataka í vöruþróun',
        'Hagnýtar æfingar og raunveruleg dæmi',
        'Notkun AI verkfæra til að flýta fyrir prótótýpugerð',
      ],
      formatToggle: {
        inPerson: 'Á staðnum',
        digital: 'Stafrænt (Vendikennsla)',
      },
      inPersonTiers: {
        tier1: {
          name: 'Grunnur',
          duration: '½ dagur',
          subtitle: 'Vörustjórnun 101',
          description:
            'Fullkomin kynning á vörustjórnun fyrir þá sem vilja skilja grunnhugtöklin og hlutverk vörustjórans.',
          features: [
            'Hvað er vörustjórnun?',
            'Hlutverk vörustjórans',
            'Grunnhugtök og orðaforði',
            'Yfirlit yfir vöruþróunarferlið',
            'Dæmi úr raunveruleikanum',
          ],
        },
        tier2: {
          name: 'Viðbót',
          duration: '1 dagur',
          subtitle: 'Módel og Verkfæri',
          description:
            'Grunnurinn plús kynning á algengum módel og verkfærum sem vörustjórar nota daglega.',
          features: [
            'Allt úr Grunni',
            'Lean Startup aðferðafræði',
            'Jobs-to-be-Done rammi',
            'Forgangsröðunarverkfæri (RICE, MoSCoW)',
            'Notendaviðtöl og rannsóknir',
            'Roadmap og áætlanagerð',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Heildstætt',
          duration: '2 dagar',
          subtitle: 'Verkleg Þjálfun + AI',
          description:
            'Ítarleg þjálfun með verklegum æfingum og prótótýpugerð með hjálp AI verkfæra.',
          features: [
            'Allt úr Viðbót',
            'Verklegar æfingar í hópum',
            'Þróun eigin vöruhugmyndar',
            'AI verkfæri fyrir prótótýpur',
            'Frá hugmynd að MVP',
            'Kynning og endurgjöf',
          ],
        },
      },
      digitalTiers: {
        tier1: {
          name: 'Grunnur',
          sessions: '1x 2.5 klst',
          subtitle: 'Vörustjórnun 101',
          description:
            'Ein gagnvirk vinnustofa sem fer yfir grunnhugtök vörustjórnunar.',
          features: [
            'Hvað er vörustjórnun?',
            'Hlutverk vörustjórans',
            'Grunnhugtök og orðaforði',
            'Gagnvirkar umræður',
            'Kennslumyndbönd til undirbúnings',
          ],
        },
        tier2: {
          name: 'Viðbót',
          sessions: '3x 2.5 klst',
          subtitle: 'Módel og Verkfæri',
          description:
            'Þrjár vinnustofur sem fara dýpra í módel og verkfæri vörustjórnunar.',
          features: [
            'Allt úr Grunni',
            'Lean og Agile aðferðir',
            'Forgangsröðunarverkfæri',
            'Notendarannsóknir',
            'Æfingar milli lota',
            'Kennslumyndbönd fyrir hverja lotu',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Heildstætt',
          sessions: '6x 2.5 klst',
          subtitle: 'Verkleg Þjálfun + AI',
          description:
            'Sex vinnustofur með verklegum æfingum og AI-studdri prótótýpugerð.',
          features: [
            'Allt úr Viðbót',
            'Verklegar æfingar',
            'Eigin vöruhugmynd þróuð',
            'AI verkfæri kynnt og notuð',
            'Hópavinna og endurgjöf',
            'Kynning á lokaverkefni',
          ],
        },
      },
      digitalNote:
        'Stafræna námskeiðið notar vendikennslu (flipped learning). Þátttakendur horfa á kennslumyndbönd heima og taka síðan þátt í gagnvirkum vinnustofum í gegnum Zoom þar sem við vinnum saman að æfingum og umræðum.',
      forWhom: 'Fyrir hvern?',
      forWhomItems: [
        'Vörustjórar sem vilja styrkja grunninn',
        'Verkefnastjórar sem vilja skilja vörustjórnun',
        'Stofnendur og frumkvöðlar',
        'Hönnuðir og þróunaraðilar sem vinna með vörustjórum',
      ],
      inquiry: 'Fyrirspurn',
      groupTitle: 'Hópafsláttur?',
      groupDesc:
        'Eruð þið fleiri úr sama fyrirtæki? Ég býð upp á sérstök kjör fyrir hópa og get haldið námskeiðið innanhúss hjá ykkur.',
      contactLink: 'Hafa samband',
      ctaTitle: 'Taktu skrefið í átt að betri vörustjórnun',
      ctaDesc:
        'Veldu það snið sem hentar þér og byrjaðu ferðina í átt að árangursríkari vöruþróun.',
      ctaCta: 'Hafa samband',
    },
  },
  en: {
    navbar: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      bookNow: 'Book Now',
      servicesDropdown: {
        overview: 'Overview',
        courses: 'Courses',
        workshops: 'Workshops',
        talks: 'Talks',
      },
    },
    footer: {
      tagline:
        'Coaching and consulting grounded in research, experience, and a healthy dose of honesty - for leaders and teams who want to do better.',
      explore: 'Explore',
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact',
      servicesTitle: 'Services',
      firstTimeManager: 'First-Time Manager',
      healthyConflicts: 'Healthy Conflicts',
      artOfFacilitation: 'The Art of Facilitation',
      agileLeadership: 'Agile Leadership',
      connectTitle: "Let's Connect",
      copyright: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    home: {
      hero: {
        badge: 'Leaders · Teams · Communication',
        titleStart: 'Better ',
        heart: 'leaders',
        and: ' and ',
        courage: 'stronger teams',
        description:
          "Coaching and consulting for leaders and teams who want to understand what actually works - and why most of it doesn't.",
        cta: 'Get in Touch',
        ctaSecondary: 'View Services',
      },
      badge: {
        leaders: '500+ Participants',
        subtitle: 'Leaders and teams',
      },
      pillars: {
        title: 'Not Your Typical Approach',
        subtitle:
          'Evidence-based foundations, practical methods, honest about what works',
        energy: {
          title: 'Evidence-based',
          desc: 'We build on research - not just methodology. What does the evidence say about how teams develop, how trust is built, and how leaders can make a real difference?',
        },
        connection: {
          title: 'Connection & Trust',
          desc: "Trust isn't given - it's built through working through disagreements together. We cover how that actually works, not the optimistic version.",
        },
        teams: {
          title: 'Teams & Collaboration',
          desc: "Most people have more bad team experiences than good ones. That's not random - and it's fixable.",
        },
      },
      services: {
        sectionLabel: 'What I Do',
        title: 'Ways for Us to Work Together',
        viewAll: 'View All Services',
        learnMore: 'Learn more',
        items: {
          firstTime: {
            title: 'First-Time Manager',
            desc: 'A six-week fast-track course for first-time managers ready to step up.',
            tags: ['Course', 'Coaching'],
          },
          conflicts: {
            title: 'Healthy Conflicts',
            desc: 'Stop avoiding difficult conversations and start solving problems.',
            tags: ['Workshop', 'Teams'],
          },
          facilitation: {
            title: 'The Art of Facilitation | Better Meetings & Workshops',
            desc: 'Learn to run meetings that people actually want to attend.',
            tags: ['Coaching', 'Skills'],
          },
        },
      },
      cta: {
        title: 'Interested?',
        description:
          "Let's talk about your challenges and see if there's a fit. No pitch, just an honest conversation.",
        bookCall: 'Book a Free Chat',
        readAbout: 'Read About Me',
      },
    },
    about: {
      title: 'Helgi Gudmundsson',
      intro:
        "Organisational and leadership coach, product coach, facilitator and teacher. I've spent over a decade working with leaders, teams and organisations - first in Sweden, now in Iceland.",
      pill1: 'Evidence-based methods',
      pill2: 'Practical - not theoretical',
      storyTitle: 'What I do and why',
      storyP1:
        "I've worked as a coach and facilitator for over ten years - coaching hundreds of leaders and teams across Scandinavia and Iceland, teaching at IHM Business School in Gothenburg, and training over 90 international facilitators as Director of Facilitator Experience at Agile People.",
      storyP2:
        "My background is in Work and Organisational Psychology from the University of Gothenburg, with specialist training in conflict resolution and mediation, and ICF ACC certification in coaching. I'm also co-author of two chapters in the book Agile People Principles, published in 2021.",
      storyP3:
        "My approach is deliberately boundary-spanning - I draw from organisational psychology, behavioural science, complexity thinking and agile coaching, because the problems I work on rarely fit neatly into one discipline. I'm also fairly evidence-based about what works and what doesn't, which occasionally means telling people that the feedback practice they've been using for years is neurologically counterproductive. That conversation usually goes well.",
      publicationLabel: 'Publication',
      publication: {
        title: 'Agile People Principles',
        subtitle: 'Your Call to Action for the Future of Work - published 2021',
        chapters:
          'Co-author of chapters on "Appreciative Feedback" and "Emergent Strategy"',
      },
      credentialsTitle: 'Certifications & Training',
      timelineTitle: 'Background',
      timeline: [
        {
          year: '2006–2013',
          title: 'Business, sales and studies',
          desc: 'BSc in Business and International Business from Reykjavik University. Then sales and marketing at Iceland Post, while beginning further studies in Sweden.',
        },
        {
          year: '2013–2017',
          title: 'Work & Organisational Psychology',
          desc: 'Fil.Cand. from the University of Gothenburg. Specialist training in conflict resolution and mediation. ICF ACC coaching certification at Gothia Academy.',
        },
        {
          year: '2017–2022',
          title: 'International coaching and teaching',
          desc: 'Founder Institute Gothenburg, Global Coach at Egencia (Expedia Group), Director of Facilitator Experience at Agile People - trained ~90 international facilitators and co-authored an ICAgile certified curriculum.',
        },
        {
          year: '2021–2023',
          title: 'Lecturer — IHM Gothenburg',
          desc: '10-week digital course in Modern Product Development. Flipped learning - pre-recorded content and practical workshops.',
        },
        {
          year: '2022–',
          title: 'Orgz — Iceland',
          desc: 'Founded my own practice. Coaching and consulting for leaders and teams - courses in modern product development, conflict coaching and facilitation.',
        },
      ],
      writingLabel: 'Writing & thinking',
      writingTitle: 'What I think about',
      writingSubtitle:
        'Articles and chapters where I go through what the research actually says - and what we often get backwards.',
      outsideWork:
        'Outside work, I chair the Tango Society of Reykjavík, am studying guiding and tour leading - and am working on becoming better at dancing than I am at giving lectures. Results are mixed.',
    },
    services: {
      title: 'Support and Coaching for',
      titleHighlight: 'Real Results',
      subtitle:
        "Whether you need 1:1 support, team coaching, or self-paced learning, I've got you covered.",
      perPackage: '/ package',
      bookService: 'Book This Service',
      moreInfoCta: 'More Information',
      moreOptions: 'More Options',
      moreOptionsSubtitle:
        'In addition to coaching and courses, I offer workshops and talks',
      seeMore: 'See More',
      items: {
        essentials: {
          title: 'First-Time Manager',
          subtitle: 'For first-time managers',
          description:
            'Stop guessing and start leading. This 6-week coaching program gives you the toolkit you need to manage people with confidence.',
          features: [
            'Weekly 1:1 coaching sessions',
            'Templates for 1:1s and feedback',
            'Slack support between sessions',
            'Personal growth plan',
          ],
          price: '$1,499',
        },
        conflict: {
          title: 'Healthy Conflicts',
          subtitle: 'For teams under tension',
          description:
            'Transform tension and friction into trust and collaboration. Scalable courses and workshops designed to help your team navigate difficult conversations and build psychological safety.\n\nAlso available as a coach and facilitator to lead better conversations when conflict is already underway.',
          features: [
            'Scalable courses and workshops',
            'Tools for navigating difficult conversations',
            'Building psychological safety in teams',
            'Coaching and facilitation for active conflicts',
          ],
          price: '$2,500',
        },
        wizardry: {
          title: 'The Art of Facilitation | Better Meetings & Workshops',
          subtitle: 'For aspiring facilitators',
          description:
            'Learn to design and lead remote meetings, events, and workshops that make remote work more enjoyable, deliver results, and keep participants engaged and focused from start to finish.',
          features: [
            'Designing and facilitating remote meetings and workshops',
            'Tools and techniques to boost participation and focus',
            'Methods for making remote work more enjoyable',
            'Practical exercises and feedback',
          ],
          price: '$499',
        },
        agile: {
          title: 'Agile Leadership',
          subtitle: 'For teams in transformation',
          description:
            'Learn to lead in complex situations and change with increased confidence and adaptability. A course that weaves together Agile and Lean methodology with human leadership skills to empower teams and create better results.',
          features: [
            'Agile core concepts and frameworks',
            'Leadership roles in Agile teams',
            'Practical exercises and case studies',
            'Implementation support',
          ],
          price: '$1,899',
        },
      },
      additional: {
        workshops: {
          title: 'Workshops',
          description:
            'Interactive workshops on-site or online - from team collaboration to leadership coaching.',
        },
        talks: {
          title: 'Talks',
          description:
            'Inspiring talks from 30 to 90 minutes - perfect for conferences and events.',
        },
        courses: {
          title: 'Courses',
          description:
            'Deeper training in specialized topics - from conflict coaching to leadership skills and better online workshops.',
        },
      },
    },
    courses: {
      badge: 'Courses',
      title: 'Practical Knowledge and Training for Modern Leaders',
      subtitle:
        'Deeper training that delivers lasting results. Choose the course that suits you or your team.',
      benefitsTitle: 'What you get from the course:',
      moreInfo: 'More Information',
      customTitle: 'Custom Courses?',
      customDescription:
        'I also run in-house courses for companies and can adapt the content to your needs.',
      contactUs: 'Contact Us',
      items: {
        conflictCoaching: {
          title: 'Conflict Coaching',
          subtitle: 'Healthier Communication and Conflicts',
          description:
            'Learn to tackle conflict with confidence and turn it into an opportunity for growth. A practical course that gives you tools to lead difficult conversations and build trust.',
          duration: '2 days (with interval)',
          format: 'On-site or Digital',
          audience: 'Managers, team leads, HR professionals',
          benefits: [
            'Understanding the nature of conflicts and how they escalate',
            'Methods to map and understand what is really going on',
            'Training in better listening and conversation techniques',
            'Increased confidence and skill in challenging conversations',
          ],
        },
        firstTimeManager: {
          title: 'First-Time Manager',
          subtitle: 'Build confidence in your new role',
          description:
            'A practical 6-week course for new managers. We cover everything from role transitions and feedback to team building and meeting facilitation.',
          duration: '6 weeks (one session per week)',
          format: 'On-site or Digital',
          audience: 'New managers, aspiring managers',
          benefits: [
            'Clearer vision of the role',
            'Tools for giving feedback',
            'Methods for prioritizing',
            'Skills for building teams',
          ],
        },
        betterOnlineMeetings: {
          title: 'Better Online Meetings',
          subtitle: 'Workshops and meetings online',
          description:
            'Stop running boring online meetings. Learn to create energy, connection, and results through the screen with the right tools and methods.',
          duration: '2 x 2 hours',
          format: 'Digital',
          audience: 'Anyone who leads online meetings',
          benefits: [
            'Increased meeting participation',
            'Technology and tools that work',
            'Methods for breaking the ice',
            'More efficient decision-making processes',
          ],
        },
        betterOnlineWorkshops: {
          title: 'Better Online Workshops',
          subtitle: 'Designing and facilitating workshops',
          description:
            'For those who want to go beyond just meetings. Learn to design and lead interactive workshops where participants are active and learn from their own experience.',
          duration: '3 sessions (3 x 2-3 hrs)',
          format: 'Digital',
          audience: 'Facilitators, coaches, teachers',
          benefits: [
            'Training from the Back of the Room methodology',
            'Designing interactive exercises',
            'Practice delivering your own workshop',
            'Peer feedback',
          ],
        },
        modernProductManagement: {
          title: 'Modern Product Management',
          subtitle: 'From idea to successful product',
          description:
            'Learn modern product management methodology - from core concepts and common models to practical tools and AI-assisted prototyping. Available as half-day, full-day, or two-day course.',
          duration: '½ - 2 days',
          format: 'On-site or Digital',
          audience: 'Product managers, project managers, founders',
          benefits: [
            'Understanding the product manager role',
            'Common models and tools of product management',
            'Practical exercises and prototyping',
            'Using AI tools in product development',
          ],
        },
      },
    },
    workshops: {
      badge: 'Workshops',
      title: 'Interactive Learning That',
      titleHighlight: 'Delivers Results',
      subtitle:
        'Whether you want to meet face-to-face or online, I offer workshops that transform teams and leaders.',
      inPersonTitle: 'On-Site',
      inPersonSubtitle: 'Workshops where we meet face to face',
      onlineTitle: 'Online',
      onlineSubtitle: 'Live guided workshops online',
      getQuote: 'Get a Quote',
      customTitle: 'Custom Workshops',
      customDescription:
        "Need something specific? I design workshops to your needs - whether it's for a small team or a large conference.",
      customCta: "Let's Talk",
      items: {
        teamDynamics: {
          title: 'Powerful Teams',
          subtitle: 'Interactive workshop for teams',
          description:
            "Strengthen your team's communication and collaboration with practical exercises and real-world examples. Participants learn how strong teams develop, the value of different communication styles, and how to build bulletproof trust.",
          duration: 'Half day (4 hrs) or full day (8 hrs)',
          format: 'On-site at your location or venue',
          benefits: [
            'Practical group exercises',
            'Real-world scenarios',
            'Team bonding and trust',
            'Action plan to take away',
          ],
        },
        leadershipIntensive: {
          title: 'Manager & Leader',
          subtitle: 'For new and experienced managers',
          description:
            'Deepen your leadership skills in a powerful learning environment. The workshop blends theory, self-reflection, and practical tools you can use immediately.',
          duration: 'Full day (8 hrs)',
          format: 'On-site with a maximum of 12 participants',
          benefits: [
            'Personal leadership assessment',
            'Role-plays and feedback',
            'Toolkit for daily use',
            'Network with other leaders',
          ],
        },
        virtualFacilitation: {
          title: 'More Effective Online Meetings',
          subtitle: 'The art of leading better and more fun remote events',
          description:
            'Transform boring remote meetings and workshops into interactive and effective sessions that participants love to join. Learn techniques and tools that hold attention and deliver real results.',
          duration: '2 x 2 hours (two sessions)',
          format: 'Live online with practical exercises',
          benefits: [
            'Techniques for online interactivity',
            'Tools and templates',
            'Practice in a safe environment',
            'Recordings for review',
          ],
        },
        remoteTeam: {
          title: 'Remote Teams That Work',
          subtitle: 'Build strong team culture at a distance',
          description:
            'Learn to build and maintain a strong team culture when the team is distributed. From communication rules to informal connections - everything needed for remote teams to thrive.',
          duration: 'Half day (4 hrs)',
          format: 'Live online with breakout rooms',
          benefits: [
            'Communication rules for remote teams',
            'Tools for informal connection',
            'Methods for building trust',
            'Templates and checklists',
          ],
        },
      },
    },
    talks: {
      badge: 'Talks',
      title: 'Ideas That',
      titleHighlight: 'Move People',
      subtitle:
        'From short sparks to deeper understanding - I get on stage and share insights that drive change.',
      chooseTitle: 'Choose What Suits You',
      chooseSubtitle:
        'Three approaches tailored to the needs of the event and audience',
      idealFor: 'Ideal for:',
      topicsLabel: 'Topics',
      formatLabel: 'Format',
      bookTalk: 'Book This Talk',
      popularTopics: 'Popular Topics',
      popularTopicsSubtitle:
        'I speak about various topics related to leaders, teams, and workplace culture',
      customTitle: 'Custom Talk?',
      customDescription:
        "If you have a specific topic in mind or want to tailor a talk to your event, I'm ready to work with you.",
      customCta: 'Get in Touch',
      items: {
        short: {
          title: 'Short & Sharp',
          duration: '30-40 minutes',
          subtitle: 'Short and punchy',
          description:
            'Perfect for lunch meetings, event openings, or when you need a creative boost that sets the tone. Dense and impactful content that encourages reflection.',
          idealFor:
            'Lunch meetings, opening speeches, energy boost for longer events',
          topics: [
            'Leadership mindset',
            'Team collaboration',
            'Change management',
            'Creative solutions',
          ],
          format: [
            '25 min talk + 5 min Q&A',
            'Interactive participation',
            'One to two key messages',
          ],
        },
        standard: {
          title: 'Keynote',
          duration: '60 minutes',
          subtitle: 'Classic format',
          description:
            'A traditional talk that goes deeper into the subject. Perfect for conferences, corporate events, or when you want to give the audience real insight and practical tools.',
          idealFor:
            'Conferences, annual meetings, corporate events, professional days',
          topics: [
            'Leadership development',
            'Psychological safety',
            'Agile mindset',
            'Team culture',
            'Challenging Conversations',
            'Feedback That Works',
          ],
          format: [
            '45-50 min talk + 10-15 min Q&A',
            'Stories and real-world examples',
            'Practical tools and tips',
          ],
        },
        deepDive: {
          title: 'Deep Dive',
          duration: '90 minutes',
          subtitle: 'Interactive talk',
          description:
            'More than a talk - this is an experience. Blends lecture, practical exercises, and discussions... perfect when you want participants to not only gain knowledge but also test-drive new methods.',
          idealFor:
            'Leadership days, development days, specialized groups wanting deeper understanding',
          topics: [
            'Conflict Coaching',
            "The Leader's Journey",
            'Developing Powerful Teams',
            'Better Change',
          ],
          format: [
            '60 min talk + 20 min exercises + 10 min discussion',
            'Interactive group exercises',
            'Deeper discussions and questions',
            'Action plan to take away',
          ],
        },
      },
      topicsList: {
        leadership: {
          title: 'Leadership Development',
          description: 'From first steps to experienced leader',
        },
        teams: {
          title: 'Powerful Teams',
          description: 'Building trust and collaboration',
        },
        agile: {
          title: 'Agile & Lean',
          description: 'Adaptability in a complex world',
        },
        creative: {
          title: 'Creative Solutions',
          description: 'Innovation and Modern Product Development',
        },
      },
    },
    contact: {
      title: "Let's talk",
      subtitle:
        'Fill out the form or book a time directly in my calendar. No pitch - just an honest conversation.',
      infoTitle: 'Contact Information',
      emailLabel: 'Send me an email',
      locationLabel: 'Location',
      locationValue: 'Reykjavík / Worldwide',
      bookCallTitle: 'Book a Call',
      bookCallDesc:
        'Skip the email back-and-forth and grab a time in my calendar for a free 15-minute intro chat.',
      viewCalendar: 'View Calendar',
      formTitle: 'Send a Message',
      firstName: 'First Name',
      firstNamePlaceholder: 'Jane',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Smith',
      email: 'Email',
      emailPlaceholder: 'jane@example.com',
      interestLabel: "I'd like to know more about...",
      interestOptions: [
        'First-Time Manager',
        'Healthy Conflicts',
        'The Art of Facilitation | Better Meetings & Workshops',
        'General inquiry',
      ],
      message: 'Message',
      messagePlaceholder:
        "Tell me a bit about the challenge you're facing or what you're trying to achieve...",
      send: 'Send Message',
      successTitle: 'Message Sent!',
      successMessage:
        "Thanks for reaching out. I'll get back to you within 24 hours.",
      sendAnother: 'Send Another Message',
    },
    conflictCoaching: {
      badge: 'Conflict Coaching',
      title: 'Healthier Communication and',
      titleHighlight: 'Workplace Conflicts',
      subtitle:
        'Learn to handle conflict with confidence and turn it into an opportunity for growth and better communication.',
      duration: '2 days (with interval)',
      audience: 'For managers and HR',
      format: 'Workshop',
      bookCta: 'Book a Spot or Get a Quote',
      aboutTitle: 'About the Course',
      aboutP1:
        "Conflict is an inevitable part of working with people. The question isn't whether it will arise, but how we handle it. In this course, you'll learn the Conflict Coaching methodology to guide people through conflict in a constructive way.",
      aboutP2:
        "We'll cover how the brain responds to threat, how we can calm situations and create space for real conversation. You'll get tools to help others (and yourself) see different perspectives and find common ground.",
      learnTitle: 'What You Learn',
      benefits: [
        'Understanding the nature of conflicts and disagreements',
        'Methods for identifying the root cause',
        'Better listening and questioning techniques',
        'Increased confidence in difficult conversations',
        'Tools for turning conflicts into opportunities',
        'Building trust in teams',
      ],
      structureTitle: 'Structure',
      curriculum: [
        {
          day: 'Day 1',
          title: 'Foundation and Analysis',
          topics: [
            'What is Conflict Coaching?',
            'Different conflict styles',
            'Neuroscience of conflict (Fight/Flight/Freeze)',
            'Situation analysis - Mapping',
          ],
        },
        {
          day: 'Interval',
          title: 'Exercises and Reflection',
          topics: [
            'Assignments in your own environment',
            'Reflection journal',
            'Preparation for day 2',
          ],
        },
        {
          day: 'Day 2',
          title: 'Solutions and Implementation',
          topics: [
            'Managing difficult conversations',
            'Future vision and solutions',
            'Role-play exercises',
            'Action plan for the future',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Managers who want to strengthen their communication skills',
        'HR professionals who support teams and managers',
        'Team leads who want to build psychological safety',
      ],
      inquiry: 'Inquiry',
      questionsTitle: 'Have Questions?',
      questionsDesc:
        "Don't hesitate to reach out if you want to know whether this course is right for you or your team.",
      contactLink: 'Contact',
      ctaTitle: 'Take the Step Toward Better Communication',
      ctaDesc:
        'Book a course for your group or sign up for the next open course.',
      ctaCta: 'Contact',
    },
    firstTimeManager: {
      badge: 'First-Time Manager',
      title: 'Build Confidence in Your',
      titleHighlight: 'New Role',
      subtitle:
        'A practical 6-week course for new managers who want to start their career with power and confidence.',
      duration: '6 weeks (one session per week)',
      audience: 'New managers',
      certificate: 'Certificate upon completion',
      bookCta: 'Registration and More Info',
      aboutTitle: 'About the Course',
      aboutP1:
        'Taking on a management position for the first time is one of the biggest leaps people take in their careers. Suddenly the job is no longer about what you do yourself, but how you get others to thrive.',
      aboutP2:
        'This course is designed to bridge the gap. We cover management fundamentals, from holding good 1:1 meetings to handling difficult personnel matters. The goal is for you to walk out with a toolkit you can use on day one.',
      learnTitle: 'What You Learn',
      benefits: [
        "Clearer vision of the manager's role",
        'Increased confidence in the new role',
        'Tools for giving feedback',
        'Methods for prioritizing and time management',
        'Skills for running effective meetings',
        'Understanding how to build teams',
      ],
      scheduleTitle: 'Schedule (6 weeks)',
      curriculum: [
        {
          week: 'Week 1',
          title: 'The Role Transition',
          desc: 'From specialist to manager. What changes? How do we build trust?',
        },
        {
          week: 'Week 2',
          title: 'Communication and Feedback',
          desc: 'Giving and receiving feedback. Difficult conversations and praise.',
        },
        {
          week: 'Week 3',
          title: 'Team Building',
          desc: "How do teams form? The manager's role in creating culture.",
        },
        {
          week: 'Week 4',
          title: 'Meetings and Organization',
          desc: 'Running meetings that deliver results. Time management and prioritization.',
        },
        {
          week: 'Week 5',
          title: 'Goal Setting and Performance',
          desc: 'How do we set goals? How do we follow up?',
        },
        {
          week: 'Week 6',
          title: 'My Management Style',
          desc: 'Summary and future vision. What kind of leader do I want to be?',
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'New managers (0-2 years in role)',
        'Specialists taking over teams',
        'Project managers with personnel responsibility',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Offer?',
      groupDesc:
        'Do you have a group of new managers? I can run this course specifically for your company.',
      contactLink: 'Contact',
      ctaTitle: 'Invest in Future Leaders',
      ctaDesc: 'Give new managers the support they need to succeed.',
      ctaCta: 'Contact',
    },
    betterOnlineMeetings: {
      badge: 'Better Online Meetings',
      title: 'Better Online Meetings',
      titleHighlight: 'Online',
      subtitle:
        'Stop running boring online meetings. Learn to create energy, connection, and results through the screen.',
      duration: '2 x 2 hrs',
      audience: 'For all meeting facilitators',
      online: '100% online',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Remote work is here to stay, but many meetings are still just "regular meetings on a computer." That rarely works well. Online, we need a different approach, different tools, and more awareness of energy and attention.',
      aboutP2:
        "In this short and practical course, you'll learn the secrets behind great online meetings. We'll cover the technology (without overcomplicating things) and the methodology that keeps people engaged.",
      learnTitle: 'What You Learn',
      benefits: [
        'Increased participation in online meetings',
        "Better use of attendees' time",
        'Technology and tools that work',
        'Methods for breaking the ice',
        'How to keep energy levels up',
        'More efficient decision-making processes',
      ],
      structureTitle: 'Structure (2 sessions)',
      sessions: [
        {
          title: 'Session 1: The Foundation and Technology',
          desc: 'How do we prepare a good online meeting? What tools do we use? How do we ensure everyone is heard?',
          topicsLabel: 'Topics:',
          topics: [
            'Setup and technical terms',
            'Miro/Mural and other collaboration tools',
            'Creating a safe space online',
            'Icebreakers and connection',
          ],
        },
        {
          title: 'Session 2: Methods and Execution',
          desc: 'How do we manage discussions? How do we work in groups? How do we end meetings with clear outcomes?',
          topicsLabel: 'Topics:',
          topics: [
            'Breakout rooms and group work',
            'Decision-making methods',
            'Dealing with "Zoom fatigue"',
            'Follow-up and next steps',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Project managers and team leads',
        'Facilitators and teachers',
        'Anyone who runs online meetings',
      ],
      inquiry: 'Inquiry',
      privateTitle: 'Private Sessions?',
      privateDesc:
        'I also offer individual consulting for those who want to sharpen their online meeting skills.',
      contactLink: 'Contact',
      ctaTitle: 'Make Your Next Online Meeting Amazing',
      ctaDesc: 'Learn the techniques and methods that make all the difference.',
      ctaCta: 'Contact',
    },
    betterOnlineWorkshops: {
      badge: 'Better Online Workshops',
      title: 'Better Online Workshops',
      titleHighlight: 'Online',
      subtitle:
        'Learn to design and lead interactive, fun, and effective online workshops.',
      duration: '3 sessions (3 x 2-3 hrs)',
      audience: 'For facilitators',
      online: '100% online',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Leading workshops online requires a different approach than in person. It\'s not enough to "move the meeting to Zoom." We need to design the experience so it keeps people engaged, creates activity, and delivers real results.',
      aboutP2:
        'In this course, you\'ll learn both the technology and the methodology. We use the "Training from the Back of the Room" approach to create active learning, and you\'ll get the opportunity to practice by designing and delivering your own "micro-workshop."',
      learnTitle: 'What You Learn',
      benefits: [
        'Technology and tools for leading online workshops',
        '"Training from the Back of the Room" methodology',
        'Designing interactive and fun workshops',
        'Maintaining participant energy and attention',
        'Practical experience delivering your own workshop',
        'Feedback from instructor and peers',
      ],
      structureTitle: 'Structure (3 sessions)',
      topicsLabel: 'Topics:',
      homework: 'Homework',
      sessions: [
        {
          title: 'Session 1: Tools and Technology',
          desc: 'The first session is about the basics - what tools and technology do we need to lead great online workshops?',
          topics: [
            'Miro/Mural and collaboration tools',
            'Zoom/Teams features for facilitators',
            'Breakout rooms and group work',
            'Technical setup and preparation',
          ],
        },
        {
          title: 'Session 2: Training from the Back of the Room',
          desc: 'In the second session, we get to know the "Training from the Back of the Room" methodology - how do we design workshops where participants learn from their own experience?',
          topics: [
            'TBR (Training from the Back of the Room) methodology',
            'Designing interactive exercises',
            'Creating learning instead of teaching',
            'Energy management and flow',
          ],
        },
        {
          title: 'Homework: Micro-Workshop',
          desc: 'Between the second and third sessions, participants design their own 15-minute micro-workshop and prepare to deliver it.',
          topics: [
            'Designing a 15-minute workshop',
            'Preparation for delivery',
            'Practice with your own material',
          ],
          isHomework: true,
        },
        {
          title: 'Session 3: Delivery and Feedback',
          desc: 'In the third and final session, participants deliver their micro-workshop and receive detailed feedback from the instructor and other participants.',
          topics: [
            'Delivering your own micro-workshop',
            'Feedback from instructor',
            'Peer feedback',
            'Next steps and continuation',
          ],
        },
      ],
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Those who lead workshops or courses',
        'Coaches and consultants',
        'Teachers and facilitators',
        'Anyone who wants to improve their facilitation skills',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Discount?',
      groupDesc:
        'Do you have a group of facilitators? I offer special rates for companies and organizations.',
      contactLink: 'Contact',
      ctaTitle: 'Master the Art of Online Workshop Facilitation',
      ctaDesc:
        'Take the next step in your professional development and learn to create unforgettable online experiences.',
      ctaCta: 'Contact',
    },
    modernProductManagement: {
      badge: 'Modern Product Management',
      title: 'Modern Product Management',
      subtitle: 'From idea to successful product',
      description:
        'Learn modern product management methodology - from core concepts and common models to practical tools and AI-assisted prototyping. Available as half-day, full-day, or two-day course.',
      duration: '½ - 2 days',
      audience: 'Product managers, project managers, founders',
      format: 'On-site or Digital',
      bookCta: 'Book Course',
      aboutTitle: 'About the Course',
      aboutP1:
        'Product management has become one of the most important disciplines in modern business. Whether you are developing software, services, or physical products, it matters to understand how we go from idea to a successful product that customers love.',
      aboutP2:
        'This course is available at three levels - from a short introduction to core concepts up to comprehensive training with practical exercises and AI-assisted prototyping. Choose the format that fits your needs and time.',
      learnTitle: 'What You Learn',
      benefits: [
        'Understanding the product manager role',
        'Common models and tools of product management',
        'Practical exercises and prototyping',
        'Using AI tools in product development',
      ],
      formatToggle: {
        inPerson: 'On-site',
        digital: 'Digital (Flipped Learning)',
      },
      inPersonTiers: {
        tier1: {
          name: 'Foundation',
          duration: '½ day',
          subtitle: 'Product Management 101',
          description:
            'Perfect introduction to product management for those who want to understand the basics and the product manager role.',
          features: [
            'What is product management?',
            'The product manager role',
            'Core concepts and vocabulary',
            'Overview of the product development process',
            'Real-world examples',
          ],
        },
        tier2: {
          name: 'Extended',
          duration: '1 day',
          subtitle: 'Models and Tools',
          description:
            'The foundation plus introduction to common models and tools that product managers use daily.',
          features: [
            'Everything from Foundation',
            'Lean Startup methodology',
            'Jobs-to-be-Done framework',
            'Prioritization tools (RICE, MoSCoW)',
            'User interviews and research',
            'Roadmap and planning',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Comprehensive',
          duration: '2 days',
          subtitle: 'Hands-on Training + AI',
          description:
            'In-depth training with practical exercises and prototyping using AI tools.',
          features: [
            'Everything from Extended',
            'Hands-on group exercises',
            'Developing your own product idea',
            'AI tools for prototyping',
            'From idea to MVP',
            'Presentation and feedback',
          ],
        },
      },
      digitalTiers: {
        tier1: {
          name: 'Foundation',
          sessions: '1x 2.5 hrs',
          subtitle: 'Product Management 101',
          description:
            'One interactive workshop covering the fundamentals of product management.',
          features: [
            'What is product management?',
            'The product manager role',
            'Core concepts and vocabulary',
            'Interactive discussions',
            'Pre-workshop video lessons',
          ],
        },
        tier2: {
          name: 'Extended',
          sessions: '3x 2.5 hrs',
          subtitle: 'Models and Tools',
          description:
            'Three workshops going deeper into product management models and tools.',
          features: [
            'Everything from Foundation',
            'Lean and Agile methods',
            'Prioritization tools',
            'User research',
            'Exercises between sessions',
            'Video lessons for each session',
          ],
          highlighted: true,
        },
        tier3: {
          name: 'Comprehensive',
          sessions: '6x 2.5 hrs',
          subtitle: 'Hands-on Training + AI',
          description:
            'Six workshops with practical exercises and AI-assisted prototyping.',
          features: [
            'Everything from Extended',
            'Hands-on exercises',
            'Develop your own product idea',
            'AI tools introduced and used',
            'Group work and feedback',
            'Final project presentation',
          ],
        },
      },
      digitalNote:
        'The digital course uses flipped learning. Participants watch video lessons at home and then participate in interactive workshops via Zoom where we work together on exercises and discussions.',
      forWhom: 'Who is it for?',
      forWhomItems: [
        'Product managers who want to strengthen their foundation',
        'Project managers who want to understand product management',
        'Founders and entrepreneurs',
        'Designers and developers who work with product managers',
      ],
      inquiry: 'Inquiry',
      groupTitle: 'Group Discount?',
      groupDesc:
        'Are there several of you from the same company? I offer special rates for groups and can run the course in-house.',
      contactLink: 'Contact',
      ctaTitle: 'Take the step toward better product management',
      ctaDesc:
        'Choose the format that suits you and start the journey toward more successful product development.',
      ctaCta: 'Contact',
    },
  },
} as const

export type TranslationKeys = typeof translations.is
